export const ROUTES_NAMES = {
  home: 'home',
  accessDenied: 'accessDenied',
  login: 'login',
  logout: 'logout',
  game: 'game',
  page: 'page',
  info: 'info',
  infoMainInfo: 'infoMainInfo',
  infoWorkingTime: 'infoWorkingTime',
  settings: 'settings',
  settingsLanguage: 'settingsLanguage',
  settingsPrint: 'settingsPrint',
  settingsLastTickets: 'settingsLastTickets',
  deposits: 'deposits',
  depositsVouchers: 'depositsVouchers',
  depositsDirectTransfer: 'depositsDirectTransfer',
  cashRegister: 'cashRegister',
  calculatorTransactions: 'calculatorTransactions',
  keyboardShortcuts: 'keyboardShortcuts',
} as const
